// extracted by mini-css-extract-plugin
export default {"error-icon":"style_error-icon__q0dzz","errorIcon":"style_error-icon__q0dzz"};